<template>
    <div>
        <homeHead></homeHead>
        <homeNav></homeNav>
        <breadcrumb  :positionData="positionData" :id="id" :second_navId="second_navId"  ></breadcrumb>
        <div class="info-box">
            <projectMenu :positionData="positionData" :id="id" :second_navId="second_navId"  ></projectMenu>
        <projectContent :projectData="projectData"></projectContent>
        </div>
        <homeFooter></homeFooter>
    </div>
</template>
<script>
import homeHead from '@/components/Public/head.vue'
import homeNav from '@/components/Public/nav.vue'
import breadcrumb from '@/components/Public/breadcrumb.vue'
import projectMenu from '@/components/Public/projectMenu.vue'
import projectContent from './projectContent.vue'
import homeFooter from '@/components/Public/footer.vue'
    export default {
        components:{
            homeHead,
            homeNav,
            breadcrumb,
            projectMenu,
            projectContent,
            homeFooter,
        },
        metaInfo(){
            let currentTitle = '';
            currentTitle=this.title;
            currentTitle = this.$store.state.webInfo.title +"-"+currentTitle;
            return {
                title: currentTitle,
                meta:[{
                     name: this.projectData&&this.projectData.name?this.projectData.name:this.$store.state.webInfo.key_words,
                     content:this.projectData&&this.projectData.desc?this.projectData.desc:this.$store.state.webInfo.describe,
                 }],
                 link: [{                
                    rel: 'asstes',
                    href: this.$url.webUrl
                }]
            } 
        },
        data(){
            return {
                title:"",
                id:null, //一级导航
                second_navId :null,//二级导航
                positionData:[],//当前位置
                projectData:{},//项目详情   
                detailId:null,
            }
        },
        created(){
            this.id = Number(this.$route.query.id)  
            this.second_navId = Number(this.$route.query.second_navId)   

            if(this.id ){
                this.$db.get(this.$url.channel.childList+'?id='+this.id).then(res=>{
                    this.positionData = res.data
                    this.positionData.forEach(element => {
                        if(element.pid==0){
                            this.title = element.title
                        }
                    });
                }).catch(err => {
            console.log(err);
          });
                let channelId =''
                channelId = this.second_navId?this.second_navId:this.id
                 this.$db.get(this.$url.channel.url + "/" + channelId).then(res=>{
                    return res.data.value 
                    // return 1 //测试
                }).then((result)=>{
                    // 根据导航ID 查找项目ID
                    this.$db.get(this.$url.project.url+'/'+result).then(res=>{
                        if(res.data&&res.data.id){
                            this.projectData = res.data
                        }
                    
                    }).catch(err => {
            console.log(err);
          });
                }).catch(err => {
            console.log(err);
          });
            }

            

        },
        methods:{
               getPositionData(id){
                   this.$db.get(this.$url.channel.childList+'?id='+id).then(res=>{
                        this.positionData = res.data
                        this.positionData.forEach(element => {
                            if(element.pid==0){
                                this.title = element.title
                            }
                        });
                    }).catch(err => {
            console.log(err);
          });
               },
               getDetailData(){
                   //获取新闻详情 数据 4 测试数据
                    this.$db.get(this.$url.project.url+"/"+this.detailId).then(res=>{
                        this.projectData = res.data
                    
                    }).catch(err => {
            console.log(err);
          });
               },
               getCateValue(channelId){
                    let that = this;
                    that.$db
                    .get(this.$url.channel.url + "/" + channelId)
                    .then(res => {
                        this.detailId = res.data.value
                        this.getDetailData()
                    }).catch(err => {
            console.log(err);
          });
                },     
        },
        watch: {
            '$route.query.id':function(value) {
                this.id = value
                this.getCateValue(this.id)
                this.getPositionData(this.id)
                // this.getDetailData()
            },
            '$route.query.second_navId':function(value) {
                if(value){
                    this.second_navId = value
                    this.getCateValue(this.second_navId )
                }else if(typeof(value) == 'undefined'){
    
                    this.getCateValue(this.id)
                    }
               
                // this.getDetailData()
            }
        }
    }
</script>
<style lang="less" scoped>
 .info-box{
     display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
 }   
</style>


// WEBPACK FOOTER //
// src/components/project/info.vue